import { ApolloError, useQuery } from "@apollo/react-hooks";
import { DocumentNode } from "graphql";
import { MY_TIME_GET_PERIOD } from "my-time/graphql/queries";

export interface UsePeriodParams {
  contractCode: string;
  year: number;
  month: number;
}

export interface UsePeriodResult<T = any> {
  data: T;
  loading: boolean;
  error?: ApolloError;
}

interface GetPeriodQueryData<T = any> {
  getPeriod: T;
}

interface GetPeriodQueryVars {
  contractCode: string;
  year: number;
  month: number;
}

/**
 * Hook to fetch a period object for a given contract and month/year.
 *
 * @param params - contractCode, year, month
 */
export function useMyTimePeriod<T = any>({
  contractCode,
  year,
  month,
}: UsePeriodParams): UsePeriodResult<T> {
  const { data, loading, error } = useQuery<
    GetPeriodQueryData<T>,
    GetPeriodQueryVars
  >(MY_TIME_GET_PERIOD as DocumentNode, {
    fetchPolicy: "cache-and-network",
    variables: {
      contractCode,
      year,
      month,
    },
  });

  return {
    data: data?.getPeriod ?? ({} as T),
    loading,
    error,
  };
}

export default useMyTimePeriod;
